!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.links = this.querySelectorAll('[js-hero-item="link"]'), this.trackClicks = this.getAttribute("data-track-clicks");
    }
    connectedCallback() {
      this.trackClicks && this.trackProductClicks();
    }
    trackProductClicks() {
      this.links.forEach((t => {
        t.addEventListener("click", (() => {
          window.dataLayer = window.dataLayer || [], window.dataLayer.push({
            event: "pdp_hero_promo",
            product_name: this.getAttribute("data-current-product"),
            promo_name: this.getAttribute("data-promo-name")
          });
        }));
      }));
    }
  }
  customElements.get("hero-item") || customElements.define("hero-item", t);
}();